/**
 * Countries and phone numbers for the tablet form fields (tablet.md section
 * 2.2): the `country` field submits an ISO 3166-1 alpha-2 code and the
 * `phone` field an E.164 number. The list matches Transfers' دولة الإصدار
 * list; the server and the tablet page both read it from here.
 */
export const ISO_COUNTRY_CODES = ('AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK ' +
    'FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IM IN IO IQ IR IS IT ' +
    'JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML ' +
    'MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM ' +
    'PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG ' +
    'TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW').split(' ');
const ISO_COUNTRY_SET = new Set(ISO_COUNTRY_CODES);
/** Shown first in the country list, in this order (section 2.2). */
export const FIRST_COUNTRY_CODES = ['JO', 'SY', 'IQ', 'PS', 'EG', 'SA', 'LB'];
export function isIsoCountryCode(value) {
    return ISO_COUNTRY_SET.has(value);
}
//# sourceMappingURL=countries.js.map